<template>
  <div class="container content">
    <div class="row justify-content-center">
      <div class="col">
        <h4>{{ building.building_name }}</h4>
        <p class="subtitle" v-if="building.portfolio !== null">
          <router-link :to="{name: 'portfolio', params: {'id': this.$route.params.id}}">{{ building.portfolio.business_name }}</router-link>
        </p>
        <p v-else class="d-block" style="margin-bottom: 39px;"></p>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-auto">
        <Navigation />
      </div>
      <div class="col">
        <h4 class="font-weight-normal">Configure Brivo Groups</h4>
        <div>For Brivo group configuration, <a href="https://www.brivo.com" target="_blank"> login to Brivo </a></div>
        <div class="row justify-content-center mt-5" v-if="!brivo">
          <div class="col-10 text-center">
            <h2>🔐</h2>
            <p>This portfolio does not have a connected Brivo account.</p>
          </div>
        </div>
        <div v-if="brivo">
          <BrivoGroup :group="group" :key="group.id" :devices="building.brivo_devices" :schedules="brivo_schedules" :admins="building.admins" :tenants="building.active_tenants" @updated="getBuilding" v-for="group in groups"></BrivoGroup>
        </div>
      </div>
    </div>
    <footer class="building-footer">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col col-md-6 col-lg-3">
            <router-link :to="{name: 'buildingresidents', params: {'id': $route.params.id, 'building_id': $route.params.building_id}}" class="btn btn-primary btn-block" tag="button">Next</router-link>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
    import api from '../../../api.js';
    import BrivoGroup from '../../../components/BrivoGroup.vue';
    import Navigation from '../../../components/BuildingNav.vue';
    import Unit from '../../../components/Unit.vue';

    export default {
        name: 'BrivoGroups',
        components: {
            BrivoGroup,
            Navigation,
            Unit,
        },
        data() {
            return {
                brivo: false,
                brivo_schedules: [],
                building: {
                    building_name: '',
                    portfolio: {
                        business_name: '',
                    }
                },
                disabled: false,
                groups: []
            };
        },
        beforeMount() {
            const self = this;
            if (self.$route.params.building_id === 'undefined') {
                self.$router.go(-1);
                return;
            }

            self.getBuilding();
        },
        methods: {
            getBuilding() {
                const self = this;
                api.getBuilding(self.$route.params.building_id)
                    .then((response) => {
                        self.building = response.building;
                        self.brivo_schedules = response.brivo_schedules;

                        if (self.building.portfolio === null) {
                            self.brivo = false;
                            if ($('.content').css('display') !== 'block') {
                                $('.content').css('display', 'block');
                                $('.content').animateCss('fadeIn');
                            }
                            return;
                        }

                        if (self.building.portfolio.brivo_account !== null) {
                            self.brivo = true;
                            self.groups = self.building.brivo_groups;
                        }

                        self.disabled = false;
                        if ($('.content').css('display') !== 'block') {
                            $('.content').css('display', 'block');
                            $('.content').animateCss('fadeIn');
                        }
                    })
                    .catch((error) => {
                        self.handleError(error);
                        self.disabled = false;
                    });
            },
            syncGroups() {
                const self = this;
                if (self.disabled) return;
                self.disabled = true;

                api.putSyncBrivoGroups(self.$route.params.id)
                    .then((response) => {
                        self.getBuilding();
                    })
                    .catch((error) => {
                        self.handleError(error);
                        self.disabled = false;
                    });
            }
        },
    };
</script>
